module.exports = __webpack_public_path__ + "img/axq-logo.c19d671e.png";